module.exports = __webpack_public_path__ + "img/icon-blockquote.c926b3b6.svg";